import { useState, useEffect, useCallback } from 'react';
import UpdateRoleForm from "../../components/update/update-role-form"; 
import { useParams } from "react-router-dom";
import { useAuth } from "../../context/AuthProvider";
import { BASE_URL } from '../../apiConfig';
import { toast } from 'sonner';
import Loading from '../../cors/Loading'; 

export default function Page() {
  const { id } = useParams();
  const { token } = useAuth();
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCategory = useCallback(async () => {
    if (!id) {
      setError("L'ID de la role est manquant."); 
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);   
    try {
      if (!token) {
        toast.error("Vous n'êtes pas authentifié. Veuillez vous connecter.");
        setError("Jeton d'authentification introuvable. Veuillez vous connecter."); 
        setLoading(false);
        return;
      }

      const res = await fetch(`${BASE_URL}/api/role/${id}`, { 
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`, 
        },
      });

      if (!res.ok) {
        const errorData = await res.json();
      }

      const data = await res.json();
      if (data.status && data.data) {
        setRole(data.data); 
      } else {
        throw new Error(data.message || "Format de données invalide de l'API."); 
      }
    } catch (err) {
      console.error("Erreur lors de la récupération de la catégorie :", err); 
      setError(err.message || "Une erreur inattendue est survenue lors de la récupération de le role."); 
      toast.error(`Erreur : ${err.message || "Échec du chargement de le role."}`); 
    } finally {
      setLoading(false); 
    }
  }, [id]); 

  useEffect(() => {
    fetchCategory();
  }, [fetchCategory]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-red-50">
        <div className="text-center p-8 bg-white rounded-xl shadow-lg border border-red-200">
          <h2 className="text-2xl font-bold text-red-700 mb-4">Erreur lors du chargement de la catégorie</h2> 
          <p className="text-gray-700 mb-6">{error}</p>
          <button
            onClick={fetchCategory} 
            className="px-6 py-3 bg-[var(--color-primary-500)] text-white font-semibold rounded-lg hover:bg-[var(--color-primary-400)] transition-colors"
          >
            Réessayer 
          </button>
        </div>
      </div>
    );
  }

  if (!role) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center p-8 bg-white rounded-xl shadow-lg border border-gray-200">
          <h2 className="text-2xl font-bold text-gray-700 mb-4">Catégorie Introuvable</h2> 
          <p className="text-gray-600">La catégorie avec l'ID "{id}" n'a pas pu être chargée ou n'existe pas.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 py-12">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl max-xl:text-3xl font-bold bg-gradient-to-r from-[var(--color-primary-500)] to-[var(--color-primary-400)] bg-clip-text text-transparent mb-4">
            Modifier le rôle
          </h1>
          <p className="text-sm max-xl:text-sm text-gray-600 max-w-2xl mx-auto">
            Modifiez les détails de cette rôle spécifique.
          </p>
        </div>

        <div className="mx-auto">
          <UpdateRoleForm role={role} />
        </div>
      </div>
    </div>
  );
}
